import React from 'react';
import {Box, Stack} from '@mui/material';
import {
  Body,
  Icon,
  Label,
  designSystemToken,
} from '@lightricks/react-design-system';
import formattedDate from '@/utils/formattedDate';
import translate from '@/utils/translate';
import {SHORT_MONTH_SHORT_DAY_COMMA_YEAR_DAY_HOUR_MINUTE_FORMAT} from '@/config/timeFormats';
import {Folder} from '@/api/fetchers/content-studio/folder';

export interface FolderCardProps {
  folder: Folder;
  onClick?: () => void;
}

function ProjectIcon() {
  return (
    <Box
      width="51px"
      height="51px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="8px"
      border={`1px solid ${designSystemToken('semantic.bg.tertiary')}`}
      flexShrink={0}
      sx={{
        backgroundColor: designSystemToken('semantic.bg.neutral-secondary'),
      }}
    >
      <Icon
        name="Navigation-Projects"
        size="medium"
        appearance="neutral"
        color={designSystemToken('semantic.fg.black')}
      />
    </Box>
  );
}

function FolderCard({folder, onClick}: FolderCardProps) {
  const {name, filesCount, createdAt} = folder;

  const formattedDateWithTime = formattedDate(
    new Date(createdAt),
    SHORT_MONTH_SHORT_DAY_COMMA_YEAR_DAY_HOUR_MINUTE_FORMAT
  );
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="326px"
      borderRadius="12px"
      padding="8px 16px 8px 8px"
      border={`1px solid ${designSystemToken('semantic.bg.tertiary')}`}
      sx={{
        backgroundColor: designSystemToken('semantic.bg.secondary'),
        boxShadow:
          '0px 0px 1px 0px rgba(14, 21, 38, 0.08), 0px 2px 8px 0px rgba(14, 21, 38, 0.06)',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Stack direction="row" alignItems="center" gap="12px">
        <ProjectIcon />
        <Stack direction="column" gap="4px" width="100%" overflow="hidden">
          <Label
            size="xl"
            color={designSystemToken('semantic.fg.primary')}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {name}
          </Label>

          {/* subtitle text */}
          <Stack direction="row" gap="4px" width="100%" overflow="hidden">
            <Body
              size="sm"
              color={designSystemToken('semantic.fg.secondary')}
              flexShrink={0}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {translate('files', {count: filesCount})}
            </Body>
            <Body
              size="sm"
              color={designSystemToken('semantic.fg.secondary')}
              flexShrink={0}
            >
              ·
            </Body>
            <Body
              size="sm"
              color={designSystemToken('semantic.fg.secondary')}
              flexShrink={0}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {formattedDateWithTime}
            </Body>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}

export default FolderCard;
